import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import sesameLogo from '@/assets/sesame.svg?inline';
import { authActions } from '@/stores/authStore';
import MaintenanceBanner from '@/components/core/MaintenanceBanner';
import { isMITX } from '@/utils/stackUtils';

const RegistrationRoute = () => {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async data => {
    setError('');
    setIsLoading(true);

    try {
      const result = await authActions.register(data);

      if (result?.error) {
        setError(result?.error);
        return;
      }

      navigate('/');
    } catch (err) {
      setError(err?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-base-200 flex flex-col items-center">
      <img src={sesameLogo} alt="Logo" className="w-48 h-32 mt-4 mb-8" />
      <div className="card w-full max-w-xl shadow">
        <div className="grid grid-cols-1 bg-base-100 rounded">
          <div className="py-20 px-10">
            <h2 className="text-2xl font-semibold mb-2 text-center">Register</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-4">
                <div className="mb-4">
                  <div className="form-control w-full mt-4">
                    <label className="label">
                      <span className="label-text text-base-content">Email</span>
                    </label>
                    <input {...register('email', { required: true })} className="input input-bordered w-full" />
                  </div>

                  <div className="form-control w-full mt-4">
                    <label className="label">
                      <span className="label-text text-base-content">First Name</span>
                    </label>
                    <input {...register('first_name', { required: true })} className="input input-bordered w-full" />
                  </div>

                  <div className="form-control w-full mt-4">
                    <label className="label">
                      <span className="label-text text-base-content">Last Name</span>
                    </label>
                    <input {...register('last_name', { required: true })} className="input input-bordered w-full" />
                  </div>
                </div>
              </div>
              {error && <p className="text-center text-error">{error}</p>}
              <button
                type="submit"
                disabled={isLoading}
                className={`btn mt-2 w-full ${isMITX() ? 'bg-[#7A0019] hover:bg-[#B10E1E] text-white' : 'btn-accent'} ${isLoading ? 'btn-disabled' : ''}`}
              >
                {isLoading && <span className="loading loading-spinner"></span>}
                {isLoading ? 'Please wait...' : 'Register'}
              </button>
            </form>
          </div>
          <MaintenanceBanner />
        </div>
      </div>
    </div>
  );
};

export default RegistrationRoute;
